var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarkerLeadOpened(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 49,
    viewBox: "0 0 40 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6669 1C9.37452 1 1.00019 9.37433 1.00019 19.655C0.932523 34.6933 18.9575 47.1627 19.6669 47.6667C19.6669 47.6667 38.4012 34.6933 38.3335 19.6667C38.3335 9.37433 29.9592 1 19.6669 1ZM19.6669 29C14.5102 29 10.3335 24.8233 10.3335 19.6667C10.3335 14.51 14.5102 10.3333 19.6669 10.3333C24.8235 10.3333 29.0002 14.51 29.0002 19.6667C29.0002 24.8233 24.8235 29 19.6669 29Z",
    fill: "#E8556F",
    stroke: "#E64360",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerLeadOpened);
export default __webpack_public_path__ + "static/media/markerLeadOpened.ea0a6e7e.svg";
export { ForwardRef as ReactComponent };